export enum ModalType {
  OVERLAY = 'overlay',
  POPUP = 'popup'
}
